<template lang="pug">
  main
    .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h5.title Items de alta {{ idAlta }}
        .columns(v-show="hayDatos")
          .column.is-10.is-offset-1.has-text-centered
            table#tbExistencias.table.is-striped
              thead
                tr
                  th # Serie
                  th Marca
                  th Modelo
                  th Observaciones
                  th Estado
              tbody
                tr(v-for="(data, index) in items" :key="data.id")
                  td 
                    a.button.is-primary(@click="irDetalleItem(data)") {{ data.serie }} 
                  td {{ data.marca }}
                  td {{ data.modelo }}
                  td {{ data.observaciones }}
                  td(v-html="getEstado(data.estado)")
                  // td
                  //   a.button.is-danger.is-small.is-rounded(@click="eliminarItem(data)")
                  //     span.icon.is-small
                  //       i.fas.fa-times

        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
</template>

<script>
import InventarioServices from '../../services/inventario/inventario';


export default {
  name: 'ListArticulos',
  props: {
    idAlta: '',
    actualizarComp: ''
  },
  watch: {
    actualizarComp () {
      this.actualizarComponente()
    }
  },
  data () {
    return {
      hayDatos: false,
      items: {}
    }
  },
  methods: {
    actualizarComponente () {
      if (this.actualizarComp) {
        this.obtenerItems()
      }
    },
    obtenerItems () {
      let id = this.idAlta
      InventarioServices.getItems(this.idAlta)
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              this.items = res
              this.hayDatos = true
              this.$emit('listaActualizada', true)
          } else {
            console.log('No hay items')
          }
        })
    },
    irDetalleItem (item) {
      this.$emit('itemToEdit', item)
    },
    eliminarItem(item) {
      this.$emit('itemToDelete', item)
    },
    getEstado (est) {
      switch (est) {
        case '1':
          return `<span class="tag is-primary">Nuevo</span>`
          break
        case '2':
          return `<span class="tag is-warning">Usado</span>`
          break
        case '3':
          return `<span class="tag is-success">Instalado</span>`
          break
        case '4':
          return `<span class="tag is-danger">No Sirve</span>`
          break
      
        default:
          break
      }
    }
  },
  created () {
    this.obtenerItems()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListArticulos.vue